import { FC, memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { IonRouterLink } from '@ionic/react'

import { Tracking, TrackingEvent } from '@/lib/tracking'
import { WALLET_SEARCH_XP } from '@/utils/route'
import { compactNumbers } from '@/utils/utils'

interface FeedXPButtonProps {
  userId: UUID
  value: number
}

const FeedXPButtonComponent: FC<FeedXPButtonProps> = ({ userId, value }) => {
  const { t } = useTranslation('common')
  const compactedValue = useMemo(
    () => compactNumbers(Math.floor(Number(value))),
    [value]
  )

  if (!(userId || value)) return null

  return (
    <>
      <IonRouterLink
        routerLink={WALLET_SEARCH_XP}
        onClick={() => Tracking.triggerEvent(TrackingEvent.XPViewed)}
      >
        <span className="flex flex-row font-bold items-center text-lg">
          <span className="ml-2">{compactedValue}</span>
          <span className="ml-1 text-primary">{t('profile.xp')}</span>
        </span>
      </IonRouterLink>
      <span className="bg-cool-gray-700 w-[1px] h-[1.4375rem] ml-2" />
    </>
  )
}

export const FeedXPButton = memo(FeedXPButtonComponent)
